import _ from "lodash";
import { CriteriaDirectoryChargeCheckboxOption } from "presentation/constant/ChargeDataEnquiry/CriteriaDirectoryCheckboxOption";
import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { useChargeDataSearchVM } from "presentation/hook/ChargeDataEnquiry/useChargeDataSearchVM";
import { useChargeDataSearchTracked } from "presentation/store/ChargeDataEnquiry/ChargeDataSearchProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import {
    FieldType,
    HPHGroupTitle,
    IFieldValue
} from "veronica-ui-component/dist/component/core";

export const ChargeDataSearchCriteriaEditChargePanel = () => {
    const CONTAINER_CONSTANT = ChargeConstant.Charge;
    const [chargeDataSearchState] = useChargeDataSearchTracked();
    const chargeDataSearchCriteria = chargeDataSearchState.searchCriteria
    const chargeDataSearchVM = useChargeDataSearchVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryChargeCheckboxOption?.find(item => chargeDataSearchState.enabledSearchCriteria[item.key]), [chargeDataSearchState.enabledSearchCriteria])

    const memoSubChgTypeOptions = useMemo(() => {
        if (!chargeDataSearchCriteria.chgTypeList || chargeDataSearchCriteria.chgTypeList.length === 0) {
            const allCommonSubChgTypeOptions = Object.values(chargeDataSearchState.dynamicOptions.subChgTypeDropdownOptions).flat();
            return _.orderBy(_.uniqBy(_.flatMap(_.concat(allCommonSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        }
        const groupOfSubChgTypeOptions = chargeDataSearchCriteria.chgTypeList?.map(chgType => chargeDataSearchState.dynamicOptions.subChgTypeDropdownOptions[chgType])
        const commonSubChgTypeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonSubChgTypeOptions;
    }, [chargeDataSearchCriteria.chgTypeList, chargeDataSearchState.dynamicOptions.subChgTypeDropdownOptions]);

    const memoChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.chgTypeList?.join(',')}
                fieldValue={chargeDataSearchCriteria.chgTypeList}
                fieldLabel={CONTAINER_CONSTANT.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chgTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDataSearchState.dynamicOptions.chgTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.CHARGE_TYPE}
                width='330px'
                isVirtualScroll={true}
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.chgTypeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    chargeDataSearchVM.onMultipleDropdownChange(e, 'chgTypeList')
                    chargeDataSearchVM.onDropdownChange(EMPTY_CHARGE_DATA_SEARCH_CRITERIA.subChgTypeList, 'subChgTypeList')
                }}
                options={chargeDataSearchState.dynamicOptions.chgTypeDropdownOptions} /> */}
        </div>
        , [chargeDataSearchCriteria.chgTypeList, chargeDataSearchState.dynamicOptions.chgTypeDropdownOptions, chargeDataSearchVM, CONTAINER_CONSTANT.CHARGE_TYPE])
    const memoSubChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.subChgTypeList?.join(',')}
                fieldValue={chargeDataSearchCriteria.subChgTypeList}
                fieldLabel={CONTAINER_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChgTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.SUB_CHARGE_TYPE}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.subChgTypeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'subChgTypeList')}
                options={memoSubChgTypeOptions} /> */}
        </div>
        , [chargeDataSearchCriteria.subChgTypeList, CONTAINER_CONSTANT.SUB_CHARGE_TYPE, memoSubChgTypeOptions, chargeDataSearchVM])
    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.billToCompList?.join(',')}
                fieldValue={chargeDataSearchCriteria.billToCompList}
                fieldLabel={CONTAINER_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDataSearchState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.BILL_TO_COMPANY}
                inputType="freeText"
                width="330px"
                mode={'multiple'}
                sort={false}
                isLimitOptions={true}
                value={chargeDataSearchCriteria.billToCompList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'billToCompList')}
                options={chargeDataSearchState.dynamicOptions.billToCompDropdownOptions} /> */}
        </div>
        , [chargeDataSearchCriteria.billToCompList, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.billToCompDropdownOptions, CONTAINER_CONSTANT.BILL_TO_COMPANY])
    const memoChargeOnCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.chgOnCompList?.join(',')}
                fieldValue={chargeDataSearchCriteria.chgOnCompList}
                fieldLabel={CONTAINER_CONSTANT.CHARGE_ON_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chgOnCompList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDataSearchState.dynamicOptions.chgOnCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.CHARGE_ON_COMPANY}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                isLimitOptions={true}
                value={chargeDataSearchCriteria.chgOnCompList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'chgOnCompList')}
                options={chargeDataSearchState.dynamicOptions.chgOnCompDropdownOptions} /> */}
        </div>
        , [chargeDataSearchCriteria.chgOnCompList, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.chgOnCompDropdownOptions, CONTAINER_CONSTANT.CHARGE_ON_COMPANY])
    const memoState = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.stateList?.join(',')}
                fieldValue={chargeDataSearchCriteria.stateList}
                fieldLabel={CONTAINER_CONSTANT.STATE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'stateList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDataSearchState.dynamicOptions.stateDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.STATE}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.stateList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'stateList')}
                options={stateDropdownOption} /> */}
        </div>
        , [chargeDataSearchCriteria.stateList, CONTAINER_CONSTANT.STATE, chargeDataSearchState.dynamicOptions.stateDropdownOptions, chargeDataSearchVM])
    const memoTarCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.tarCodeList?.join(',')}
                fieldValue={chargeDataSearchCriteria.tarCodeList}
                fieldLabel={CONTAINER_CONSTANT.TARIFF_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tarCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDataSearchState.dynamicOptions.tarCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.TARIFF_CODE}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.tarCodeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'tarCodeList')}
                options={chargeDataSearchState.dynamicOptions.tarCodeDropdownOptions} /> */}
        </div>
        , [chargeDataSearchCriteria.tarCodeList, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.tarCodeDropdownOptions, CONTAINER_CONSTANT.TARIFF_CODE])
    // const memoBillingType = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={CONTAINER_CONSTANT.BILLING_TYPE}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={chargeDataSearchCriteria.billingTypeList?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'billingTypeList')}
    //             options={billingTypeDropdownOption} />
    //     </div>
    //     , [chargeDataSearchCriteria.billingTypeList, chargeDataSearchVM, CONTAINER_CONSTANT.BILLING_TYPE])
    const memoManSysInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={chargeDataSearchCriteria.manSysInd?.join(',')}
                fieldValue={chargeDataSearchCriteria.manSysInd}
                fieldLabel={CONTAINER_CONSTANT.MANUAL_SYSTEM_IND}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'manSysInd'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDataSearchState.dynamicOptions.manSysDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={CONTAINER_CONSTANT.MANUAL_SYSTEM_IND}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.manSysInd?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'manSysInd')}
                options={manSysDropdownOption} /> */}
        </div>
        , [chargeDataSearchCriteria.manSysInd, CONTAINER_CONSTANT.MANUAL_SYSTEM_IND, chargeDataSearchState.dynamicOptions.manSysDropdownOptions, chargeDataSearchVM]);
    const memoOpsFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={CONTAINER_CONSTANT.OPS_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: chargeDataSearchCriteria.opsDateFrom, endDate: chargeDataSearchCriteria.opsDateTo }}
                onDatesChange={chargeDataSearchVM.onDateRangeChange}
            />
        </div>
        , [chargeDataSearchCriteria.opsDateFrom, chargeDataSearchCriteria.opsDateTo, chargeDataSearchVM.onDateRangeChange, CONTAINER_CONSTANT.OPS_DATE_RANGE])
    const memoTarCodeDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.tarCodeDesc || ''}
                fieldValue={chargeDataSearchCriteria.tarCodeDesc}
                fieldLabel={CONTAINER_CONSTANT.TARIFF_CODE_DESC}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'tarCodeDesc'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDataSearchCriteria.tarCodeDesc, chargeDataSearchVM, CONTAINER_CONSTANT.TARIFF_CODE_DESC])
    const memoExpMsg = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.expMsg || ''}
                fieldValue={chargeDataSearchCriteria.expMsg}
                fieldLabel={CONTAINER_CONSTANT.EXCEPTION_MESSAGE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'expMsg'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDataSearchCriteria.expMsg, chargeDataSearchVM, CONTAINER_CONSTANT.EXCEPTION_MESSAGE])

    const memoPanel = useMemo(() =>
        <div className='im-charge-data-search-criteria-group'>
            <HPHGroupTitle titleText={CONTAINER_CONSTANT.CHARGE} />
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.opsDate ? <>{memoOpsFromTo}</> : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.stateList ? memoState : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.tarCodeList ? memoTarCode : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.chgOnCompList ? memoChargeOnCompany : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.billToCompList ? memoBillToCompany : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.chgTypeList ? <>{memoChgType}</> : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.subChgTypeList ? <>{memoSubChgType}</> : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.tarCodeDesc ? memoTarCodeDesc : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.expMsg ? memoExpMsg : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.manSysInd ? memoManSysInd : null}
            </CriteriaItemContainer>
        </div>, [CONTAINER_CONSTANT.CHARGE, chargeDataSearchState.enabledSearchCriteria.billToCompList, chargeDataSearchState.enabledSearchCriteria.chgOnCompList, chargeDataSearchState.enabledSearchCriteria.chgTypeList, chargeDataSearchState.enabledSearchCriteria.expMsg, chargeDataSearchState.enabledSearchCriteria.manSysInd, chargeDataSearchState.enabledSearchCriteria.opsDate, chargeDataSearchState.enabledSearchCriteria.stateList, chargeDataSearchState.enabledSearchCriteria.subChgTypeList, chargeDataSearchState.enabledSearchCriteria.tarCodeDesc, chargeDataSearchState.enabledSearchCriteria.tarCodeList, memoBillToCompany, memoChargeOnCompany, memoChgType, memoExpMsg, memoManSysInd, memoOpsFromTo, memoState, memoSubChgType, memoTarCode, memoTarCodeDesc]);


    if (!enabledCriteria) return null;
    return memoPanel;
};
